// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".t7MrR{height:100%;border-radius:8px;overflow:hidden;background:#fff;-webkit-box-shadow:0 4px 8px 0 rgba(0,0,0,.2);box-shadow:0 4px 8px 0 rgba(0,0,0,.2);display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}._2kaaA{width:100%;position:relative;display:inline-block;height:200px;background:#ccc;text-align:center;vertical-align:center;line-height:160px;overflow:hidden}._2eRSj{padding:20px;background:#fff}._2o9rK{font-family:Poppins,sans-serif;font-style:normal;font-weight:500;font-size:1.6em;color:#222;margin-bottom:20px;text-align:center}._23_50{font-family:Mulish,sans-serif;font-style:normal;font-weight:400;font-size:1.2em;text-align:left;margin-bottom:1em}", ""]);
// Exports
exports.locals = {
	"card": "t7MrR",
	"cardHeader": "_2kaaA",
	"cardBody": "_2eRSj",
	"textTitle": "_2o9rK",
	"textContent": "_23_50"
};
module.exports = exports;
